import { ServerDate } from "./server-date.class"

export const calculateRemainingTime = (
  finishedAt: string | Date | number
): number => {
  const now = ServerDate.now()
  return Math.max(new ServerDate(finishedAt).getTime() - now, 0)
}
